import type { FC } from "hono/jsx";
import { useState } from "hono/jsx";

import { ServerTime } from "../islands/ServerTime.tsx";

export const HomePage: FC<{ messages: string[] }> = (props) => {
  return (
    <div class="space-y-8">
      {/* Messages Section */}
      <div class="flex flex-col gap-4">
        <h1 class="text-4xl font-bold text-primary">Hello Hono!</h1>
        <ul class="menu bg-base-200 w-56 rounded-box">
          {props.messages.map((message, index) => {
            return (
              <li key={index}>
                <a>{message}!!</a>
              </li>
            );
          })}
        </ul>
      </div>

      {/* Interactive App Section */}
      <div class="hero bg-base-200 rounded-box p-6">
        <div class="hero-content text-center">
          <div class="max-w-md">
            <h1 class="text-5xl font-bold text-primary">Hello hono/jsx/dom!</h1>
            <p class="py-6">
              Welcome to your refined app with DaisyUI + Tailwind 4.
            </p>
          </div>
        </div>
      </div>

      <div class="card bg-base-100 shadow-xl border border-base-300">
        <div class="card-body">
          <h2 class="card-title">Example of useState()</h2>
          <Counter />
        </div>
      </div>

      <div class="card bg-base-100 shadow-xl border border-base-300">
        <div class="card-body">
          <h2 class="card-title">Example of API fetch()</h2>
          <ServerTime />
        </div>
      </div>
    </div>
  );
};

function Counter() {
  const [count, setCount] = useState(0);
  return (
    <button
      type="button"
      class="btn btn-primary"
      onClick={() => setCount(count + 1)}
    >
      You clicked me <span class="badge badge-lg">{count}</span> times
    </button>
  );
}
